module.exports = __webpack_public_path__ + "static/media/BANNER_WEB_MOVILIDAD.2c7dfd2d.JPG";